// @flow

import fuzzysearch from 'fuzzysearch';

import toLowerCaseString from './toLowerCaseString';

const fuzzy = (needle: string, haystack: string) => {
  needle = toLowerCaseString(needle).replace(/ /g, '');
  haystack = toLowerCaseString(haystack);
  return fuzzysearch(needle, haystack);
};

export default fuzzy;
